import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";
import { CardList } from '../CardList'

class TherapistList extends Component {
  render() {
    const { action } = this.props;
    const therapists = this.props.therapists.filter((o) => !o._destroy);

    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Doctor Name</th>
            <th>First Visit</th>
            <th>Last Visit</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            therapists.map((t) => {
              return (
                <tr key={t.id}>
                  <td>{t.doctor_name}</td>
                  <td>{t.admitted_at && moment(t.admitted_at).format("MM/DD/YYYY")}</td>
                  <td>{t.discharged_at && moment(t.discharged_at).format("MM/DD/YYYY")}</td>
                  <td>
                    {
                      action === "edit" &&
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.editTherapist(t);
                        }}>
                        Edit
                      </a>
                    }
                  </td>
                </tr>
              );
            })
          }
          {
            action == "edit" &&
            <tr>
              <td colSpan={7} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    this.props.newTherapist();
                  }}>
                  Add Therapist
                </Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    therapists: state.therapists,
    action: state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    newTherapist: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "therapist" }
      })
    },
    editTherapist: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName: "therapist", resource }
      })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TherapistList);
